import * as Sentry from '@sentry/react';
import { ApiError } from './api';

export const initSentry = () => {
  const dsn = window.SENTRY_DSN;

  if (!dsn) {
    return;
  }

  const environment = window.ENVIRONMENT || 'development';

  Sentry.init({
    dsn,
    environment,
    tracesSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    replaysSessionSampleRate: environment === 'production' ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
  });
};

export const captureUnexpectedError = (
  error: unknown,
  extra?: Record<string, unknown>,
) => {
  if (error instanceof ApiError) {
    return;
  }

  console.error(error, extra);
  Sentry.captureException(error, extra ? { extra } : undefined);
};
